<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-27 09:38:24
 * @FilePath: 
 * @Description: 技师业绩
-->
<template>
  <div class="c-p-t-20 full_page_grey performance_page">
    <date-tab-com
      ref="dateTabRef"
      @change="handleChangeDateType"
      @changeDate="handleChangeDateData"
    ></date-tab-com>
    <div class="table_list_con" ref="tablistRef">
      <div class="table_con">
        <div class="c-f c-ft-25 table_title_con">
          <p class="tc">工号</p>
          <p class="tc">名称</p>
          <p class="tc">排钟</p>
          <p class="tc">点钟</p>
          <p class="tc">加钟</p>
          <p class="tc">总钟数</p>
          <p class="clock_ticheng_con tc c-fc-center">
            <span>做钟提成</span>
            <span>(含服务费)</span>
          </p>
          <p class="tc">加班补贴</p>
          <p class="tc">销售提成</p>
          <p class="tc">充值办卡提成</p>
          <p class="tc">总收入</p>
        </div>
        <div class="table_item_con">
          <div class="c-f c-ft-25" v-for="(v, i) in performanceList" :key="i">
            <p class="tc p-tb-15">
              {{ i == performanceList.length - 1 ? "合计" : v.EmployeeCode }}
            </p>
            <p class="tc p-tb-15">
              {{ v.EmployeeName }}
            </p>
            <p class="tc p-tb-15">{{ v.SortClockCount }}</p>
            <p class="tc p-tb-15">{{ v.PointClockCount }}</p>
            <p class="tc p-tb-15">{{ v.AppendClockMoney }}</p>
            <p class="tc p-tb-15">{{ v.AllClock }}</p>
            <p class="tc p-tb-15">{{ v.AllTicheng }}</p>
            <p class="tc p-tb-15">{{ v.OvertimeMoney }}</p>
            <p class="tc p-tb-15">{{ v.SalePersumeMoney }}</p>
            <p class="tc p-tb-15">{{ v.ShareAmount }}</p>
            <p class="tc p-tb-15">{{ v.TotalIncome }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTabCom from "./comps/dateTabCom.vue";
import { getJishiPromotionList } from "@/api/performance";
import BScroll from "better-scroll";
export default {
  name: "JishiPerformance",
  props: {},
  data() {
    return {
      performanceList: [],
    };
  },
  components: { DateTabCom },
  created() {},

  mounted() {
    this.$nextTick(() => {
      this.dateType = this.$refs.dateTabRef.nowDateType;
      this.handleGetJishiPerformance();
      this.tableScroll = new BScroll(this.$refs.tablistRef, {
        click: false,
        scrollX: true,
        scrollY: true,
      });
    });
  },
  methods: {
    handleChangeDateType(type) {
      this.dateType = type;
      if (this.dateType !== 4) {
        this.handleGetJishiPerformance();
      }
    },
    handleChangeDateData(dateArr) {
      this.startDate = dateArr[0];
      this.endDate = dateArr[1];
      this.handleGetJishiPerformance();
    },
    handleGetJishiPerformance() {
      const queryData = {
        TimeType: this.dateType,
        VpnId: this.$store.state.vpnId,
      };
      if (this.dateType == 4) {
        queryData.BeginTime = this.startDate;
        queryData.EndTime = this.endDate;
      }
      getJishiPromotionList(queryData).then((res) => {
        res.forEach((item) => {
          item.AllClock =
            item.SortClockCount +
            item.SkipClockCount +
            item.PointClockCount +
            item.NonPointClockCount;
          item.AllTicheng =
            item.PointPersumeMoney +
            item.AppendPersumeMoney +
            item.NonPointPersumeMoney;
        });
        this.performanceList = res;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.performance_page {
  overflow: hidden;
}
.table_list_con {
  // overflow-x: auto;
  margin: 20px 10px;
  .table_con {
    width: 1650px;
  }
  .table_title_con {
    width: 100%;
    height: 70px;
    color: #fff;
    p {
      height: 100%;
      line-height: 70px;
      background: var(--tc);
      &.clock_ticheng_con {
        line-height: 35px;
      }
    }
  }
  p {
    width: 150px;
    flex-shrink: 0;
  }
  .table_item_con {
    background: #fff;
  }
}
</style>
